import { AnyAction } from "redux";
import { fulfilled } from "../../../checkout/utils";
import * as AT from "../actionTypes";
import { ILoggedInAgent } from "../../../../../models/server/retailerInfo";

const initialState: ILoggedInAgent = {};

const salesAgentReducer = (state = initialState, action: AnyAction): ILoggedInAgent => {
    switch (action.type) {
        case fulfilled(AT.RETAILER_UPDATE_SELECTED_AGENT): {
            return {
                ...state,
                ...action.payload.selectedAgent,
            };
        }
        default: {
            return state;
        }
    }
};

export default salesAgentReducer;
